import React from 'react';
import PropTypes from 'prop-types';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import { DASHBOARD_VIEW } from '../../constants/dashboardViewMode';
import './DashboardViewToggle.css';

const classes = getBEMClasses('dashboard-view-toggle');

const DashboardViewToggle = ({ value, onChange, t, label }) => {
  const labelText = label != null && label !== '' ? label : t('Dashboard view');
  const aria = label != null && label !== '' ? label : t('Dashboard view');
  return (
    <div className={classes()}>
      <span className={classes('label')}>{labelText}</span>
      <div className={classes('segment')} role="group" aria-label={aria}>
        <button
          type="button"
          className={classes('option', { active: value === DASHBOARD_VIEW.basic })}
          onClick={() => onChange(DASHBOARD_VIEW.basic)}
          aria-pressed={value === DASHBOARD_VIEW.basic}>
          {t('Basic')}
        </button>
        <button
          type="button"
          className={classes('option', { active: value === DASHBOARD_VIEW.pro })}
          onClick={() => onChange(DASHBOARD_VIEW.pro)}
          aria-pressed={value === DASHBOARD_VIEW.pro}>
          {t('Pro')}
        </button>
      </div>
    </div>
  );
};

DashboardViewToggle.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  /** If omitted, uses t('Dashboard view') for label + aria. */
  label: PropTypes.string
};

export default DashboardViewToggle;
